import { getSynthTrackColor } from './synthTrackColors.js'

export function buildActiveKeyColorsFromPlayback(tracks, playbackTimeMs) {
  const states = new Map()
  const time = Math.max(0, Number(playbackTimeMs) || 0)
  for (const track of Array.isArray(tracks) ? tracks : []) {
    if (!track?.visual?.isActiveTrack) continue
    for (const event of Array.isArray(track.events) ? track.events : []) {
      if (event?.note == null) continue
      if (!(Number(event.startMs) <= time && time < Number(event.endMs))) continue
      states.set(event.note, {
        count: (states.get(event.note)?.count ?? 0) + 1,
        color: getSynthTrackColor(track.trackIndex).solid,
      })
    }
  }
  return states
}
